(() => {
  const kabo = window.KABO || {};
  const availability = kabo.worldCollections || {};
  const aliases = { outdoor: 'weekend', work: 'studio' };
  const worlds = ['clean', 'drive', 'weekend', 'studio', 'living'];
  const canonicalWorld = (world) => aliases[world] || world;

  const worldHref = (world) => {
    const canonical = canonicalWorld(world);
    return availability[canonical]
      ? `/collections/kabo-${canonical}`
      : `/collections/all?view=kabo-${canonical}`;
  };

  const worldLabel = (world) => ({
    clean: 'KABO Clean',
    drive: 'KABO Drive',
    weekend: 'KABO Weekend',
    studio: 'KABO Studio',
    living: 'KABO Living'
  }[canonicalWorld(world)] || 'den Produkten');

  const worldFromUrl = (url) => {
    const direct = url.pathname.match(/^\/collections\/kabo-(clean|drive|weekend|studio|living|outdoor|work)\/?$/);
    if (direct) return canonicalWorld(direct[1]);
    if (url.pathname === '/collections/all') {
      const view = url.searchParams.get('view') || '';
      const match = view.match(/^kabo-(clean|drive|weekend|studio|living|outdoor|work)$/);
      if (match) return canonicalWorld(match[1]);
    }
    return '';
  };

  const currentUrl = new URL(window.location.href);
  const currentWorld = worldFromUrl(currentUrl);
  const isLegacyCurrent = /\/collections\/kabo-(outdoor|work)\/?$/.test(currentUrl.pathname)
    || /^kabo-(outdoor|work)$/.test(currentUrl.searchParams.get('view') || '');
  const isUnavailableDirect = currentWorld
    && /^\/collections\/kabo-/.test(currentUrl.pathname)
    && !availability[currentWorld];
  const isFallbackWithRealCollection = currentWorld
    && currentUrl.pathname === '/collections/all'
    && availability[currentWorld];

  if (currentWorld && (isLegacyCurrent || isUnavailableDirect || isFallbackWithRealCollection)) {
    window.location.replace(worldHref(currentWorld));
    return;
  }

  document.querySelectorAll('a[href]').forEach((link) => {
    const rawHref = link.getAttribute('href');
    if (!rawHref) return;
    let url;
    try { url = new URL(rawHref, window.location.origin); } catch (error) { return; }
    const world = worldFromUrl(url);
    if (world) link.setAttribute('href', worldHref(world));
  });

  const backLink = document.querySelector('.product-back-link');
  if (backLink) {
    const params = new URLSearchParams(window.location.search);
    const rawOriginWorld = params.get('from') || '';
    let originWorld = canonicalWorld(rawOriginWorld);
    if (!worlds.includes(originWorld)) originWorld = '';

    if (!originWorld) {
      originWorld = canonicalWorld(kabo.productWorld || '');
      if (!worlds.includes(originWorld)) originWorld = '';
    }

    if (originWorld) {
      backLink.setAttribute('href', worldHref(originWorld));
      const text = backLink.querySelector('span:last-child');
      if (text) text.textContent = `Zurück zu ${worldLabel(originWorld)}`;
    }

    if (params.has('from')) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('from');
      window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
    }
  }

  const airClean = kabo.airClean;
  if (!airClean) return;
  const cleanTopLink = Array.from(document.querySelectorAll('.kabo-world-card__top')).find((link) => /KABO\s+Clean/i.test(link.textContent || ''));
  const cleanCard = cleanTopLink?.closest('.kabo-world-card');
  if (!cleanCard) return;
  const image = cleanCard.querySelector('.kabo-world-card__image');
  const featuredLink = cleanCard.querySelector('.kabo-world-card__featured');
  const featuredTitle = featuredLink?.querySelector('strong');
  if (image && airClean.image) {
    image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.setAttribute('src', airClean.image); image.setAttribute('alt', 'KABO AirClean');
  }
  if (featuredLink) featuredLink.setAttribute('href', `${airClean.url}?from=clean`);
  if (featuredTitle) featuredTitle.textContent = 'KABO AirClean';
})();